import React from 'react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  className?: string;
}
export function PrimaryButtonPurple({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`bg-violet-600 hover:bg-violet-700 text-white rounded-lg px-4 py-2.5 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center ${className}`} {...props} data-id="element-201">
      {children}
    </button>;
}
export function PrimaryButtonGreen({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`bg-green-600 hover:bg-green-700 text-white rounded-lg px-4 py-2.5 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center ${className}`} {...props} data-id="element-202">
      {children}
    </button>;
}
export function SecondaryButtonOutline({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`border border-gray-300 text-gray-700 hover:bg-gray-50 bg-white rounded-lg px-4 py-2.5 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center ${className}`} {...props} data-id="element-203">
      {children}
    </button>;
}